import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    accordion: {
        backgroundColor: '#fff',
        borderRadius: '12px !important',
        boxShadow: '0 1px 3px rgba(16, 24, 40, 0.08)',
        marginBottom: 16,
        overflow: 'hidden',
        '&:before': { display: 'none' },
        '&.Mui-expanded': { margin: '0 0 16px' },
    },
    summary: {
        minHeight: 56,
        padding: '0 20px',
        '&.Mui-expanded': { minHeight: 56 },
        '& .MuiAccordionSummary-content': {
            margin: '14px 0',
            alignItems: 'center',
            gap: 12,
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: '14px 0',
        },
    },
    title: {
        fontSize: 16,
        fontWeight: 700,
        color: '#1C375D',
    },
    hint: {
        fontSize: 13,
        color: '#8a92a3',
        fontWeight: 500,
    },
    details: {
        display: 'block',
        padding: '0 20px 20px',
        borderTop: '1px solid #eef0f3',
    },
}));

export default function MarketingSpendOverviewAccordion({ title, hint, children }) {
    const classes = useStyles();
    return (
        <Accordion className={classes.accordion} defaultExpanded={false}>
            <AccordionSummary
                className={classes.summary}
                expandIcon={<ExpandMoreIcon htmlColor="#1C375D" />}
                aria-controls="marketing-spend-overview"
                id="marketing-spend-overview-header"
            >
                <span className={classes.title}>{title}</span>
                {hint ? <span className={classes.hint}>{hint}</span> : null}
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
                {children}
            </AccordionDetails>
        </Accordion>
    );
}
